<template>
  <div class="theme-picker-card">
    <div class="theme-picker-card__name">
      {{ $t(themeGroup.label) }}
    </div>
    <div class="theme-picker-card__options">
      <button
        v-for="variation in themeGroup.variations"
        :key="variation.id"
        class="theme-picker-card__option customization-drawer__theme-preview"
        :class="`editor-theme--${themeGroup.id}-${variation.id}`"
        aria-describedby="theme-picker-card__aria-description"
        @click="selectTheme(variation)"
      >
        <span class="comet-screenreader-only">
          <!-- Human-readable name for this theme variation, such as "Coastal Reef 2" -->
          {{ $t(themeGroup.label) }} {{ variation.id }}
        </span>
        <template v-if="themeGroup.id === pageTheme.name && variation.id === pageTheme.variation">
          <span class="comet-screenreader-only">{{ $t('selected') }}</span>
          <NebulaIcon
            class="theme-picker-card__check editor-theme__check"
            symbol-id="check"
          />
        </template>
      </button>
      <span
        id="theme-picker-card__aria-description"
        class="theme-picker-card__aria-description"
      >
        {{ $t('Press Enter to apply this theme') }}
      </span>
    </div>
  </div>
</template>

<script>
import { NebulaIcon } from '@discoveryedu/nebula-components';
import { get } from 'lodash-es';
import { mapActions, mapState } from 'pinia';
import {
  useEditorStore,
} from '@/stores';
import * as types from '@/lib/constants/store';

export default {
  name: 'ThemePickerCard',
  components: {
    NebulaIcon,
  },
  props: {
    themeGroup: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useEditorStore, [
      'currentPage',
    ]),
    pageTheme() {
      return {
        name: 'default',
        variation: 1,
        ...get(this, 'currentPage.options.theme'),
      };
    },
  },
  methods: {
    ...mapActions(useEditorStore, [
      types.UPDATE_PAGE_OPTIONS,
    ]),
    selectTheme(variation) {
      this[types.UPDATE_PAGE_OPTIONS]({
        options: {
          ...this.currentPage.options,
          theme: {
            ...this.pageTheme,
            name: this.themeGroup.id,
            variation: variation.id,
          },
        },
      });
    },
  },
};
</script>

<style lang="stylus">
.theme-picker-card {
  border-radius: $nebula-border-radius-badge-default;
  box-shadow: $comet-shadow-z-shadow-2;
  overflow: hidden;
  width: 100%;

  &__name {
    padding: $nebula-space-1x;
  }

  &__options {
    display: flex;
  }

  &__option {
    align-items: center;
    border: none;
    border-radius: 0;
    display: flex;
    height: 42px;
    justify-content: center;
    width: 100%;
  }

  &__check {
    display: block;
  }

  &__aria-description {
    display: none;
  }
}
</style>
